import isDefined from "../../../Core/isDefined";
export function filterViewerAndScreenSize(item, viewState) {
  var _item$screenSize;
  const currentViewer = viewState.terria.mainViewer.viewerMode;
  const screenSize = (_item$screenSize = item.screenSize) !== null && _item$screenSize !== void 0 ? _item$screenSize : "any";
  if (viewState.useSmallScreenInterface) {
    return (!isDefined(item.controller.viewerMode) || item.controller.viewerMode === currentViewer) && (screenSize === "any" || item.screenSize === "small");
  } else {
    return (!isDefined(item.controller.viewerMode) || item.controller.viewerMode === currentViewer) && (screenSize === "any" || item.screenSize === "medium");
  }
}